'use es6';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { alignPropType } from './TablePropTypes';
import { isIE11 } from '../../utils/BrowserTest';
import { TABLE_HEADER_HEIGHT } from 'HubStyleTokens/sizes';

// In IE11, the height grows uncontrollably if not set to a fixed value.
import { jsxs as _jsxs } from "react/jsx-runtime";
const fixedHeightMixin = css(["height:", ";"], TABLE_HEADER_HEIGHT);
const StyledContent = styled.div.withConfig({
  displayName: "SortTH_Content__StyledContent",
  componentId: "lwhccu-0"
})(["align-items:center;display:flex;margin-left:", ";text-align:", ";", ";"], ({
  align
}) => align === 'right' && 'auto', ({
  align
}) => align === 'right' && 'right', isIE11() ? fixedHeightMixin : null);
const SortTH_Content = ({
  align,
  arrowsNode,
  children
}) => /*#__PURE__*/_jsxs(StyledContent, {
  align: align,
  children: [children, arrowsNode]
});
SortTH_Content.propTypes = {
  align: alignPropType,
  arrowsNode: PropTypes.node,
  children: PropTypes.node
};
SortTH_Content.displayName = 'UISortTH_Content';
export default SortTH_Content;